<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('bill.import_resource_type_from_file')}}</div>
    <div slot="body">
      <a-form
        :form="form.fc">
        <a-alert type="warning" class="mb-2">
          <template v-slot:message>
            <div class="messages-list">
              <p>{{ $t('system.text_501') }}<a-button type="link" @click="handleDownloadTemplate">{{$t('system.text_502')}}</a-button></p>
            </div>
          </template>
        </a-alert>
        <div class="pt-3 pb-3">
          <a-form-item>
            <a-upload-dragger
              v-decorator="decorators.fileList"
              :beforeUpload="beforeUpload"
              :fileList="fileList"
              :accept="accept"
              :remove="handleRemove">
              <div class="pt-3 pb-3">
                <p class="ant-upload-drag-icon"><a-icon type="inbox" /></p>
                <p class="ant-upload-text">{{$t('system.text_505')}}</p>
                <p class="ant-upload-hint">{{$t('system.text_506')}}</p>
              </div>
            </a-upload-dragger>
          </a-form-item>
        </div>
     </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import XLSX from 'xlsx'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'BillShieldImportResourceTypeDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      accept: '.xlsx',
      fileList: [],
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        fileList: ['fileList', {
          rules: [
            { required: true, message: this.$t('system.text_507') },
          ],
        }],
      },
    }
  },
  methods: {
    beforeUpload (file) {
      this.fileList = [file]
      return false
    },
    handleClearFile () {
      this.fileList = []
    },
    handleRemove () {
      this.handleClearFile()
    },
    handleDownloadTemplate () {
      const data = [
        ['产品明细Code', '产品明细'],
      ]
      const filename = '账单配置-导入资源类型模板.xlsx'
      const ws_name = 'Sheet1'
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.aoa_to_sheet(data)
      ws['!cols'] = [
        { wch: 20 },
        { wch: 20 },
      ]
      XLSX.utils.book_append_sheet(wb, ws, ws_name)
      XLSX.writeFile(wb, filename)
    },
    async handleConfirm () {
      try {
        if (!this.fileList || this.fileList.length === 0) {
          this.form.fc.setFieldsValue({
            fileList: undefined,
          })
        }
        const that = this
        await this.form.fc.validateFields()
        var fileReader = new FileReader()
        fileReader.onload = async function (ev) {
          try {
            var data = ev.target.result
            var workbook = XLSX.read(data, {
              type: 'binary',
            }) // 以二进制流方式读取得到整份excel表格对象
            var persons = [] // 存储获取到的数据
          } catch (e) {
            console.log('文件类型不正确')
            return
          }
          for (var sheet in workbook.Sheets) {
            if (workbook.Sheets.hasOwnProperty(sheet)) {
              persons = persons.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]))
            }
          }
          that.params.ok(persons)
          that.cancelDialog()
        }
        // 以二进制方式打开文件
        fileReader.readAsBinaryString(this.fileList[0])
      } catch (err) {
        throw err
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
  .messages-list p{
    margin-bottom: 2px;
  }
</style>
